import { createReducer, on } from "@ngrx/store";
import * as HsnActions from "./hsn.actions";
import { initialHsnState } from "./hsn.state";

export const hsnReducer = createReducer(
  initialHsnState,

  // Load HSNs
  on(HsnActions.loadHsns, (state) => ({ ...state, loading: true })),

  on(HsnActions.loadHsnSuccess, (state, { hsn }) => ({
    ...state,
    hsn,
    loading: false,
  })),

  on(HsnActions.loadHsnFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Create HSN
  on(HsnActions.createHsn, (state) => ({ ...state, loading: true })),

  on(HsnActions.createHsnSuccess, (state) => ({
    ...state,
    loading: false,
  })),

  on(HsnActions.createHsnFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Deactivate HSN
  on(HsnActions.deactivateHsn, (state) => ({ ...state, loading: true })),

  on(HsnActions.deactivateHsnSuccess, (state) => ({
    ...state,
    loading: false,
  })),

  on(HsnActions.deactivateHsnFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  })),

  // Delete HSN
  on(HsnActions.deleteHsn, (state) => ({ ...state, loading: true })),

  on(HsnActions.deleteHsnSuccess, (state) => ({
    ...state,
    loading: false,
  })),

  on(HsnActions.deleteHsnFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
